import { MarketingLayout } from "@/components/marketing/marketing-layout";
import { LegalPageView } from "@/components/legal/legal-page";
import { LEGAL_PAGES } from "@/lib/legal";
import { useDocumentHead } from "@/lib/document-head";

export function TermsPage() {
  useDocumentHead({
    title: "Terms of Service | Swift MVP",
    description:
      "Terms of service for using Swift MVP - scope of work, delivery timelines, payments, and client responsibilities.",
    canonical: "/terms",
  });
  return (
    <MarketingLayout>
      <div className="mx-auto max-w-3xl px-6 py-12">
        <LegalPageView page={LEGAL_PAGES.terms} />
      </div>
    </MarketingLayout>
  );
}
